import {LicenseInfo} from "@mui/x-license";

LicenseInfo.setLicenseKey(
  "9b0b7b37868443779d30aa5739961d04Tz05MDgxNyxFPTE3NDc1OTc2MzgwMDAsUz1wcm8sTE09cGVycGV0dWFsLEtWPTI=",
);